import React from 'react';
import './ImageViewer.css';
import { IV_SUBTITLE } from 'src/data/content';

export const ImageViewer = ({ showViewer, imageObject, closeViewHandler }) => {
  return (
    <>
      <div
        className={`iv-overlay  ${showViewer ? 'visible' : 'hidden'}`}
        onClick={closeViewHandler}
      ></div>
      <div className={`image-viewer ${showViewer ? 'visible' : 'hidden'}`}>
        <div className='iv-close' onClick={closeViewHandler}>
          &#x2716;
        </div>
        <main className='iv-content row mx-auto'>
          <div className='iv-image-wrapper'>
            <img src={imageObject?.url} className='iv-image' alt='viewer' />
          </div>
          <section className='iv-sidebar p-2'>
            <h3 className='iv-sidebar-title'>{imageObject.name}</h3>
            <div className='iv-sidebar-tags'>
              {imageObject &&
                imageObject.tags?.map((tag) => {
                  return (
                    <span key={tag} className='iv-image-tag'>
                      {tag}
                    </span>
                  );
                })}
            </div>
            <div className='iv-sidebar-description'>
              {imageObject.description}
              <br />
              Taken on {imageObject?.exif?.camera}
            </div>
            <div className='iv-sidebar-exif'>
              <span className='exif-aperture'>{imageObject?.exif?.aperture}</span>
              <span className='exif-shutter-speed'>{imageObject?.exif?.shutterSpeed}</span>
              <span className='exif-focal-length'>{imageObject?.exif?.focalLength}</span>
              <span className='exif-iso-speed'>ISO{imageObject?.exif?.ISO}</span>
            </div>
          </section>
          <footer className='iv-footer mx-auto'>{IV_SUBTITLE}</footer>
        </main>
      </div>
    </>
  );
};
